/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { resolveIncludes as r } from "./sources/resolver.js";
var e = {
  shaders: {
    vertexShader: r("background/background.vert"),
    fragmentShader: r("background/background.frag")
  },
  attributes: new Map([["a_pos", 0]])
};
export { e as background };